import QueryString from "qs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiService from "@/common/services/apiService";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { hideLoader, showLoader } from "@/store/loaderSlice";
import { GetServerSideProps } from "next";
import { RootState } from "@/store/store";
const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead")
);
const FullPageLoader = dynamic(() => import("@/Components/FullPageLoader"));
const CategoryStories = dynamic(
  () =>
    import("@/Components/category/category-all-stories/category-all-stories")
);

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }
  const slug = ctx?.params?.slug;

  const res = await fetch(`${baseUrl}get-component-by-slug/${slug}`);
  // let ssrdata = await res.;
  await res.text();

  let apiRes = null;
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep",
    },
    {
      encodeValuesOnly: false,
    }
  );

  apiRes = await fetch(`${baseUrl}categories?${decodeURIComponent(query)}`);

  const ssrdata = await apiRes.json();

  const listData = ssrdata.data;
  if (listData?.length === 0) return { notFound: true };

  const blocksData = listData[0].attributes || [];
  const seoData = listData[0].attributes.seo || [];
  return {
    props: {
      blocksData,
      seoData,
      slug,
    },
  };
};

interface CategoryProps {
  blocksData: any;
  seoData: any;
}

const Category: React.FC<CategoryProps> = ({ blocksData, seoData }) => {
  const router = useRouter();
  const { slug } = router.query;

  const loading = useSelector((state: RootState) => state.loader.loading);
  const dispatch = useDispatch();

  const [data, setData] = useState(blocksData);
  const [seo, setSeo] = useState(seoData);

  const fetchData = async () => {
    dispatch(showLoader());
    const query = QueryString.stringify(
      {
        filters: {
          slug: {
            $eq: slug,
          },
        },
        populate: "deep, 10",
      },
      {
        encodeValuesOnly: false,
      }
    );

    const list: any = await apiService.getapi(
      "categories?" + decodeURIComponent(query)
    );
    let listData = list.data.data;
    listData = listData[0];
    const seoData = listData.attributes.seo;
    setData(listData.attributes);
    setSeo(seoData);
  };

  useEffect(() => {
    fetchData().then(() => {
      window.scrollTo(0, 0);
      dispatch(hideLoader());
    });
    // eslint-disable-next-line
  }, [slug]);

  // let blocks = props.blocks;
  return (
    <div id="root">
      {seo && <HocHead seo={seo} />}

      <div className="middle-sction middle-pad">
        {loading ? <FullPageLoader /> : <CategoryStories block={data} />}
      </div>
    </div>
  );
};

export default Category;
